import { render } from "./PlatformDetailsModal.vue.js?vue&type=template&id=582abfc8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformDetailsModal.vue?vue&type=template&id=582abfc8"
import script from "./PlatformDetailsModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformDetailsModal.vue?vue&type=script&lang=js"
export * from "./PlatformDetailsModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/affiliate-platform/PlatformDetailsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "582abfc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('582abfc8', __exports__)) {
    api.reload('582abfc8', __exports__)
  }
  
  module.hot.accept("./PlatformDetailsModal.vue.js?vue&type=template&id=582abfc8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformDetailsModal.vue?vue&type=template&id=582abfc8", () => {
    api.rerender('582abfc8', render)
  })

}


export default __exports__